import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, List, ListItem, IconButton } from '@mui/material';

import { MarketSignal } from '../../types';

type Props = {
  items: MarketSignal[];
  onRemove: (item: MarketSignal) => void;
};

export const PackagePositionList: React.FC<Props> = ({ items, onRemove }) => (
  <Box className="package-signal-list">
    {items.length > 0 && (
      <Typography variant="body2" gutterBottom>
        Список инструментов в пакетной заявке
      </Typography>
    )}

    <List disablePadding>
      {items.map((item, index) => (
        <ListItem
          key={index}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #e0e0e0',
            py: 1,
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="body2">{item.symbol}</Typography>
            <Typography variant="body2">
              {(item.typeSignal === 1 && 'Покупка') ||
                (item.typeSignal === 2 && 'Продажа') ||
                (item.typeSignal === 3 && 'Закрытие')}
            </Typography>
            <Typography variant="body2">{item.weight}%</Typography>
            {item.stopLoss && <Typography variant="body2">SL {item.stopLoss}</Typography>}
            {item.takeProfit && <Typography variant="body2">TP {item.takeProfit}</Typography>}
          </Box>
          <IconButton onClick={() => onRemove(item)} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </ListItem>
      ))}
    </List>
  </Box>
);
